module.exports = __webpack_public_path__ + "img/kafka.e722ca45.png";